module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/jjksfw.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fjjksfw.png
// module id = 2ctj
// module chunks = 93